import React, { useState } from "react";
import { useForm } from "react-hook-form";
import api from "../../api/api";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button, Grid, Box } from "@mui/material";
import Alerts from "../Alerts";

const Edit = ({ selectedBanner, setOption }) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [warning, setWarning] = useState({});
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: selectedBanner, // Assegura que os valores iniciais sejam carregados
  });

  const type = watch("type");
  const imgUrl = watch("imgUrl");
  const imgUrlMobile = watch("imgUrlMobile");

  const handleOpenSnackbar = () => {
    setOpenSnackbar(true);
  };
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const onSubmit = (data) => {
    api
      .post(`/banners/body`, data) // POST para atualização
      .then((response) => {
        console.log(response.data);
        handleOpenSnackbar();
        setWarning({
          type: "success",
          message: "Banner criado com sucesso",
        });
        setOption("view"); // Retorna para a visualização após a atualização
      })
      .catch((error) => {
        console.error("Erro na atualização", error);
        handleOpenSnackbar();
        setWarning({
          type: "error",
          message: "Erro ao criar banner",
        });
      });
  };

  return (
    <div className="space-y-4">
      <Button
        onClick={() => setOption("view")}
        variant="outlined"
        color="primary"
        sx={{ mb: 5 }}
      >
        <ArrowBackIcon />
        Voltar
      </Button>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        {/* Nome */}
        <div>
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700"
          >
            Nome
          </label>

          <input
            type="text"
            {...register("name", { required: "Este campo é obrigatório" })}
            className="block w-full p-2 border rounded-md"
            placeholder="Título"
          />
          <p className="text-xs text-gray-500 mt-2">
            Nome para o banner, será exibido somente no painel administrativo
          </p>
          {errors.name && (
            <span className="text-red-500">{errors.name.message}</span>
          )}
        </div>

        {/* Descrição */}
        <div>
          <label
            htmlFor="text"
            className="block text-sm font-medium text-gray-700"
          >
            Descrição
          </label>

          <input
            type="text"
            {...register("text", { required: "Este campo é obrigatório" })}
            className="block w-full p-2 border rounded-md"
            placeholder="Descrição"
          />
          <p className="text-xs text-gray-500 mt-2">
            Descrição para o banner, será exibido somente no painel
            administrativo
          </p>
          {errors.text && (
            <span className="text-red-500">{errors.text.message}</span>
          )}
        </div>

        <div>
          <label
            htmlFor="href"
            className="block text-sm font-medium text-gray-700"
          >
            Link
          </label>

          <input
            type="text"
            {...register("href")}
            className="block w-full p-2 border rounded-md"
            placeholder="Href"
          />
          <p className="text-xs text-gray-500 mt-2">
            Caminho de redirecionamento, este categoryID pode ser retirado do
            próprio site, ou na seção de categorias.
          </p>
          {errors.href && (
            <span className="text-red-500">{errors.href.message}</span>
          )}
        </div>

        <div className="flex gap-2 w-full">
          <div className="w-1/2">
            <label
              htmlFor="imgUrl"
              className="block text-sm font-medium text-gray-700"
            >
              Imagem Desktop
            </label>

            <input
              type="text"
              {...register("imgUrl")}
              className="block w-full p-2 border rounded-md"
              placeholder="URL da Imagem Desktop"
            />
            <p className="text-xs text-gray-500 mt-2">
              Link da imagem Desktop (1028x1296)
            </p>
            {errors.text && (
              <span className="text-red-500">{errors.imgUrl.message}</span>
            )}
            {imgUrl && (
              <Grid xs={12} md={6} mt={1}>
                <Box
                  component="img"
                  src={imgUrl}
                  alt="Preview Standard"
                  sx={{
                    width: "100%",
                    maxWidth: 250,
                    height: 300,
                    objectFit: "contain",
                    borderRadius: 1,
                  }}
                />
              </Grid>
            )}
          </div>

          <div className="w-1/2">
            <label
              htmlFor="imgUrlMobile"
              className="block text-sm font-medium text-gray-700"
            >
              Imagem Mobile
            </label>

            <input
              type="text"
              {...register("imgUrlMobile")}
              className="block w-full p-2 border rounded-md"
              placeholder="URL da Imagem Mobile"
            />
            <p className="text-xs text-gray-500 mt-2">
              Link da imagem Mobile (1028x1296)
            </p>
            {errors.imgUrlMobile && (
              <span className="text-red-500">
                {errors.imgUrlMobile.message}
              </span>
            )}
            {imgUrlMobile && (
              <Grid xs={12} md={6} mt={1}>
                <Box
                  component="img"
                  src={imgUrlMobile}
                  alt="Preview Mobile"
                  sx={{
                    width: "100%",
                    maxWidth: 250,
                    height: 300,
                    objectFit: "contain",
                    borderRadius: 1,
                  }}
                />
              </Grid>
            )}
          </div>
        </div>

        <div className="flex justify-start">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition ease-in-out duration-150 mt-4"
          >
            Salvar Alterações
          </button>
        </div>
      </form>

      <Alerts
        open={openSnackbar}
        handleClose={handleCloseSnackbar}
        type={warning.type}
        message={warning.message}
      />
    </div>
  );
};

export default Edit;
